import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import sk from "./locales/sk.json";
import type { AppLocale } from "./types";

export { useTranslation } from "react-i18next";

export type Translation = typeof en;

type SupportedLocaleLoader = {
  translationFileLoader: () => Promise<Translation>;
};

export const supportedLocales: Record<AppLocale, SupportedLocaleLoader> = {
  sk: {
    translationFileLoader: async () => sk,
  },
  de: {
    translationFileLoader: async () => de,
  },
  es: {
    translationFileLoader: async () => es,
  },
  en: {
    translationFileLoader: async () => en,
  },
} as const;

export const bestLanguageTags: AppLocale[] = ["en"];
export const fallback: AppLocale = "en";
export const keySeparator = ".";
